import type { Section } from '@/access/sections'
import { useAccess } from '@/access/useAccess'
import { Card, EmptyRow, PageHeader } from '@/ui'
import { SUBTITLES } from './sectionCopy'
import { useBadgeCounts } from './useBadgeCounts'

/** W0 stand-in: the real header, and an empty card until W0.5 builds the screen. */
export function SectionPlaceholder({ section }: { section: Section }) {
  const { membership } = useAccess()
  const counts = useBadgeCounts()
  const subtitle = SUBTITLES[section.id]({
    condoName: membership.condominium_name,
    waiting: (counts.approvals ?? 0) + (counts.bookings ?? 0),
  })
  return (
    <>
      <PageHeader title={section.label} subtitle={subtitle} />
      <Card pad={0}>
        <EmptyRow
          icon="construction"
          title="Tela em construção"
          description="Esta tela chega na próxima fase do painel."
        />
      </Card>
    </>
  )
}
